var _rect, _rect2, _rect3, _g, _circle, _g2, _circle2, _g3, _circle3, _g4, _circle4, _g5, _circle5, _g6, _circle6, _g7, _circle7, _g8, _circle8, _g9, _circle9, _g10, _circle10, _g11, _circle11, _g12, _circle12, _g13, _circle13, _g14, _circle14, _g15, _circle15, _g16, _circle16, _g17, _circle17, _g18, _circle18, _g19, _circle19, _g20, _circle20, _g21, _circle21, _g22, _circle22, _g23, _mask, _path, _path2, _g24, _mask2, _path3, _path4, _g25, _mask3, _path5, _path6, _g26, _circle23, _g27, _circle24, _g28, _circle25, _circle26, _g29, _circle27, _g30, _circle28, _g31, _circle29, _g32, _circle30, _g33, _circle31, _g34, _circle32, _g35, _circle33, _g36, _circle34, _g37, _circle35, _circle36, _g38, _circle37, _g39, _circle38, _g40, _circle39, _g41, _circle40, _circle41, _g42, _g43, _g44, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 300,
    viewBox: "0 0 505 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 127,
    y: 161.002,
    width: 61,
    height: 22,
    rx: 3,
    fill: "url(#paint0_linear_2617_303)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 237,
    y: 161.002,
    width: 60,
    height: 22,
    rx: 3,
    fill: "url(#paint1_linear_2617_303)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 347,
    y: 163.002,
    width: 60,
    height: 22,
    rx: 3,
    fill: "url(#paint2_linear_2617_303)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 399.438,
    cy: 49.7234,
    r: 0.752656,
    transform: "rotate(-98.5946 399.438 49.7234)",
    fill: "#76FFD5"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 399.438,
    cy: 49.7234,
    r: 0.752656,
    transform: "rotate(-98.5946 399.438 49.7234)",
    fill: "url(#paint3_radial_2617_303)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370.428,
    cy: 16.4281,
    r: 0.376328,
    transform: "rotate(-98.5946 370.428 16.4281)",
    fill: "#76FFD5"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 370.428,
    cy: 16.4281,
    r: 0.376328,
    transform: "rotate(-98.5946 370.428 16.4281)",
    fill: "url(#paint4_radial_2617_303)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 390.47,
    cy: 33.1908,
    r: 0.376328,
    transform: "rotate(-98.5946 390.47 33.1908)",
    fill: "#76FFD5"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 390.47,
    cy: 33.1908,
    r: 0.376328,
    transform: "rotate(-98.5946 390.47 33.1908)",
    fill: "url(#paint5_radial_2617_303)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 316.617,
    cy: 50.1915,
    r: 1.12898,
    transform: "rotate(86.7297 316.617 50.1915)",
    fill: "#76FFD5"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 316.617,
    cy: 50.1915,
    r: 1.12898,
    transform: "rotate(86.7297 316.617 50.1915)",
    fill: "url(#paint6_radial_2617_303)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter4_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.383,
    cy: 58.0082,
    r: 0.752656,
    transform: "rotate(86.7297 334.383 58.0082)",
    fill: "#76FFD5"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 334.383,
    cy: 58.0082,
    r: 0.752656,
    transform: "rotate(86.7297 334.383 58.0082)",
    fill: "url(#paint7_radial_2617_303)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter5_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 190.706,
    cy: 57.3115,
    r: 0.752656,
    transform: "rotate(86.7297 190.706 57.3115)",
    fill: "#76FFD5"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 190.706,
    cy: 57.3115,
    r: 0.752656,
    transform: "rotate(86.7297 190.706 57.3115)",
    fill: "url(#paint8_radial_2617_303)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter6_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 411.995,
    cy: 107.078,
    r: 0.752656,
    transform: "rotate(24.1185 411.995 107.078)",
    fill: "#76FFD5"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 411.995,
    cy: 107.078,
    r: 0.752656,
    transform: "rotate(24.1185 411.995 107.078)",
    fill: "url(#paint9_radial_2617_303)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter7_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 218.348,
    cy: 53.2561,
    r: 0.376328,
    transform: "rotate(86.7297 218.348 53.2561)",
    fill: "#76FFD5"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 218.348,
    cy: 53.2561,
    r: 0.376328,
    transform: "rotate(86.7297 218.348 53.2561)",
    fill: "url(#paint10_radial_2617_303)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter8_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 306.397,
    cy: 56.0525,
    r: 0.376328,
    transform: "rotate(86.7297 306.397 56.0525)",
    fill: "#76FFD5"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 306.397,
    cy: 56.0525,
    r: 0.376328,
    transform: "rotate(86.7297 306.397 56.0525)",
    fill: "url(#paint11_radial_2617_303)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter9_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 254.995,
    cy: 165.996,
    r: 0.752656,
    transform: "rotate(24.1185 254.995 165.996)",
    fill: "#76FFD5"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 254.995,
    cy: 165.996,
    r: 0.752656,
    transform: "rotate(24.1185 254.995 165.996)",
    fill: "url(#paint12_radial_2617_303)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter10_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.438,
    cy: 47.7234,
    r: 0.752656,
    transform: "rotate(-98.5946 116.438 47.7234)",
    fill: "#76FFD5"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 116.438,
    cy: 47.7234,
    r: 0.752656,
    transform: "rotate(-98.5946 116.438 47.7234)",
    fill: "url(#paint13_radial_2617_303)"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter11_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.4284,
    cy: 14.4281,
    r: 0.376328,
    transform: "rotate(-98.5946 87.4284 14.4281)",
    fill: "#76FFD5"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 87.4284,
    cy: 14.4281,
    r: 0.376328,
    transform: "rotate(-98.5946 87.4284 14.4281)",
    fill: "url(#paint14_radial_2617_303)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter12_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.47,
    cy: 31.1908,
    r: 0.376328,
    transform: "rotate(-98.5946 107.47 31.1908)",
    fill: "#76FFD5"
  }))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 107.47,
    cy: 31.1908,
    r: 0.376328,
    transform: "rotate(-98.5946 107.47 31.1908)",
    fill: "url(#paint15_radial_2617_303)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter13_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.2492,
    cy: 99.3111,
    r: 1.12898,
    transform: "rotate(24.1185 73.2492 99.3111)",
    fill: "#76FFD5"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 73.2492,
    cy: 99.3111,
    r: 1.12898,
    transform: "rotate(24.1185 73.2492 99.3111)",
    fill: "url(#paint16_radial_2617_303)"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter14_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.3627,
    cy: 87.1322,
    r: 0.752656,
    transform: "rotate(24.1185 88.3627 87.1322)",
    fill: "#76FFD5"
  }))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 88.3627,
    cy: 87.1322,
    r: 0.752656,
    transform: "rotate(24.1185 88.3627 87.1322)",
    fill: "url(#paint17_radial_2617_303)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter15_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 85.2922,
    cy: 124.907,
    r: 0.752656,
    transform: "rotate(24.1185 85.2922 124.907)",
    fill: "#76FFD5"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 85.2922,
    cy: 124.907,
    r: 0.752656,
    transform: "rotate(24.1185 85.2922 124.907)",
    fill: "url(#paint18_radial_2617_303)"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter16_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54.9945,
    cy: 109.693,
    r: 0.752656,
    transform: "rotate(24.1185 54.9945 109.693)",
    fill: "#76FFD5"
  }))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 54.9945,
    cy: 109.693,
    r: 0.752656,
    transform: "rotate(24.1185 54.9945 109.693)",
    fill: "url(#paint19_radial_2617_303)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter17_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 94.4074,
    cy: 98.4973,
    r: 0.376328,
    transform: "rotate(24.1185 94.4074 98.4973)",
    fill: "#76FFD5"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 94.4074,
    cy: 98.4973,
    r: 0.376328,
    transform: "rotate(24.1185 94.4074 98.4973)",
    fill: "url(#paint20_radial_2617_303)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter18_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73.7521,
    cy: 111.081,
    r: 0.376328,
    transform: "rotate(24.1185 73.7521 111.081)",
    fill: "#76FFD5"
  }))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 73.7521,
    cy: 111.081,
    r: 0.376328,
    transform: "rotate(24.1185 73.7521 111.081)",
    fill: "url(#paint21_radial_2617_303)"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter19_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100.359,
    cy: 172.844,
    r: 0.752656,
    transform: "rotate(24.1185 100.359 172.844)",
    fill: "#76FFD5"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 100.359,
    cy: 172.844,
    r: 0.752656,
    transform: "rotate(24.1185 100.359 172.844)",
    fill: "url(#paint22_radial_2617_303)"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter20_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.4973,
    cy: 74.4973,
    r: 0.376328,
    transform: "rotate(24.1185 87.4973 74.4973)",
    fill: "#76FFD5"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 87.4973,
    cy: 74.4973,
    r: 0.376328,
    transform: "rotate(24.1185 87.4973 74.4973)",
    fill: "url(#paint23_radial_2617_303)"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter21_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.4492,
    cy: 148.844,
    r: 0.752656,
    transform: "rotate(24.1185 93.4492 148.844)",
    fill: "#76FFD5"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 93.4492,
    cy: 148.844,
    r: 0.752656,
    transform: "rotate(24.1185 93.4492 148.844)",
    fill: "url(#paint24_radial_2617_303)"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.7195,
    height: 86.4016,
    rx: 9,
    transform: "matrix(1 0 -0.000594958 1 101.154 68.2095)",
    fill: "url(#paint25_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.499702,
    y: 0.5,
    width: 84.7195,
    height: 85.4016,
    rx: 8.5,
    transform: "matrix(1 0 -0.000594958 1 101.154 68.2095)",
    stroke: "url(#paint26_linear_2617_303)"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-1_2617_303",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.021 76.4219C101.024 72.0036 104.607 68.4219 109.026 68.4219H177.866C182.836 68.4219 186.863 72.4513 186.86 77.4219L186.84 111.623H101L101.021 76.4219Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.021 76.4219C101.024 72.0036 104.607 68.4219 109.026 68.4219H177.866C182.836 68.4219 186.863 72.4513 186.86 77.4219L186.84 111.623H101L101.021 76.4219Z",
    fill: "url(#paint27_linear_2617_303)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.021 76.4219C101.024 71.4513 105.056 67.4219 110.026 67.4219H176.866C182.389 67.4219 186.864 71.899 186.86 77.4219C186.863 73.0036 182.836 69.4219 177.865 69.4219H109.025C104.607 69.4219 101.023 72.5559 101.021 76.4219ZM186.84 111.623H101H186.84ZM101 111.623L101.026 68.4219L101 111.623ZM186.866 68.4219L186.84 111.623L186.866 68.4219Z",
    fill: "url(#paint28_linear_2617_303)",
    mask: "url(#path-50-inside-1_2617_303)"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.7195,
    height: 86.4016,
    rx: 9,
    transform: "matrix(1 0 -0.000594958 1 211.217 67)",
    fill: "url(#paint29_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.499702,
    y: 0.5,
    width: 84.7195,
    height: 85.4016,
    rx: 8.5,
    transform: "matrix(1 0 -0.000594958 1 211.218 67)",
    stroke: "url(#paint30_linear_2617_303)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-54-inside-2_2617_303",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.084 75.2124C211.087 70.7941 214.671 67.2124 219.089 67.2124H287.929C292.9 67.2124 296.927 71.2418 296.924 76.2124L296.903 110.413H211.063L211.084 75.2124Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.084 75.2124C211.087 70.7941 214.671 67.2124 219.089 67.2124H287.929C292.9 67.2124 296.927 71.2418 296.924 76.2124L296.903 110.413H211.063L211.084 75.2124Z",
    fill: "url(#paint31_linear_2617_303)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.084 75.2124C211.087 70.2418 215.119 66.2124 220.09 66.2124H286.93C292.452 66.2124 296.927 70.6896 296.924 76.2124C296.926 71.7941 292.899 68.2124 287.928 68.2124H219.088C214.67 68.2124 211.086 71.3464 211.084 75.2124ZM296.903 110.413H211.063H296.903ZM211.063 110.413L211.089 67.2124L211.063 110.413ZM296.929 67.2124L296.903 110.413L296.929 67.2124Z",
    fill: "url(#paint32_linear_2617_303)",
    mask: "url(#path-54-inside-2_2617_303)"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.7195,
    height: 86.4016,
    rx: 9,
    transform: "matrix(1 0 -0.000594958 1 321.281 67)",
    fill: "url(#paint33_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.499702,
    y: 0.5,
    width: 84.7195,
    height: 85.4016,
    rx: 8.5,
    transform: "matrix(1 0 -0.000594958 1 321.281 67)",
    stroke: "url(#paint34_linear_2617_303)"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-3_2617_303",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.147 75.2124C321.15 70.7941 324.734 67.2124 329.152 67.2124H397.992C402.963 67.2124 406.99 71.2418 406.987 76.2124L406.967 110.413H321.126L321.147 75.2124Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M321.147 75.2124C321.15 70.7941 324.734 67.2124 329.152 67.2124H397.992C402.963 67.2124 406.99 71.2418 406.987 76.2124L406.967 110.413H321.126L321.147 75.2124Z",
    fill: "url(#paint35_linear_2617_303)",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M321.147 75.2124C321.15 70.2418 325.182 66.2124 330.153 66.2124H396.993C402.516 66.2124 406.99 70.6896 406.987 76.2124C406.99 71.7941 402.962 68.2124 397.992 68.2124H329.152C324.733 68.2124 321.15 71.3464 321.147 75.2124ZM406.967 110.413H321.126H406.967ZM321.126 110.413L321.152 67.2124L321.126 110.413ZM406.992 67.2124L406.967 110.413L406.992 67.2124Z",
    fill: "url(#paint36_linear_2617_303)",
    mask: "url(#path-58-inside-3_2617_303)"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.104,
    cy: 145.11,
    r: 0.259941,
    transform: "rotate(-24.5487 89.104 145.11)",
    fill: "#76FFD5"
  }))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.104,
    cy: 145.11,
    r: 0.259941,
    transform: "rotate(-24.5487 89.104 145.11)",
    fill: "url(#paint37_radial_2617_303)"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 93.4299,
    cy: 146.135,
    r: 0.12997,
    transform: "rotate(-24.5487 93.4299 146.135)",
    fill: "#76FFD5"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.4299,
    cy: 146.135,
    r: 0.12997,
    transform: "rotate(-24.5487 93.4299 146.135)",
    fill: "url(#paint38_radial_2617_303)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 89.7663,
    cy: 154.382,
    r: 0.12997,
    transform: "rotate(-24.5487 89.7663 154.382)",
    fill: "#76FFD5"
  }))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.7663,
    cy: 154.382,
    r: 0.12997,
    transform: "rotate(-24.5487 89.7663 154.382)",
    fill: "url(#paint39_radial_2617_303)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.0798,
    cy: 133.472,
    r: 0.276456,
    transform: "rotate(-146.463 90.0798 133.472)",
    fill: "url(#paint40_radial_2617_303)"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter28_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431.249,
    cy: 128.492,
    r: 1.12898,
    transform: "rotate(24.1185 431.249 128.492)",
    fill: "#76FFD5"
  }))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 431.249,
    cy: 128.492,
    r: 1.12898,
    transform: "rotate(24.1185 431.249 128.492)",
    fill: "url(#paint41_radial_2617_303)"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter29_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 443.292,
    cy: 154.089,
    r: 0.752656,
    transform: "rotate(24.1185 443.292 154.089)",
    fill: "#76FFD5"
  }))), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 443.292,
    cy: 154.089,
    r: 0.752656,
    transform: "rotate(24.1185 443.292 154.089)",
    fill: "url(#paint42_radial_2617_303)"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter30_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 412.995,
    cy: 138.873,
    r: 0.752656,
    transform: "rotate(24.1185 412.995 138.873)",
    fill: "#76FFD5"
  }))), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 412.995,
    cy: 138.873,
    r: 0.752656,
    transform: "rotate(24.1185 412.995 138.873)",
    fill: "url(#paint43_radial_2617_303)"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter31_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 452.407,
    cy: 127.678,
    r: 0.376328,
    transform: "rotate(24.1185 452.407 127.678)",
    fill: "#76FFD5"
  }))), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 452.407,
    cy: 127.678,
    r: 0.376328,
    transform: "rotate(24.1185 452.407 127.678)",
    fill: "url(#paint44_radial_2617_303)"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter32_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 431.752,
    cy: 140.262,
    r: 0.376328,
    transform: "rotate(24.1185 431.752 140.262)",
    fill: "#76FFD5"
  }))), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 431.752,
    cy: 140.262,
    r: 0.376328,
    transform: "rotate(24.1185 431.752 140.262)",
    fill: "url(#paint45_radial_2617_303)"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter33_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 451.449,
    cy: 178.025,
    r: 0.752656,
    transform: "rotate(24.1185 451.449 178.025)",
    fill: "#76FFD5"
  }))), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 451.449,
    cy: 178.025,
    r: 0.752656,
    transform: "rotate(24.1185 451.449 178.025)",
    fill: "url(#paint46_radial_2617_303)"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 447.104,
    cy: 174.291,
    r: 0.259941,
    transform: "rotate(-24.5487 447.104 174.291)",
    fill: "#76FFD5"
  }))), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.104,
    cy: 174.291,
    r: 0.259941,
    transform: "rotate(-24.5487 447.104 174.291)",
    fill: "url(#paint47_radial_2617_303)"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 451.43,
    cy: 175.315,
    r: 0.12997,
    transform: "rotate(-24.5487 451.43 175.315)",
    fill: "#76FFD5"
  }))), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 451.43,
    cy: 175.315,
    r: 0.12997,
    transform: "rotate(-24.5487 451.43 175.315)",
    fill: "url(#paint48_radial_2617_303)"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 447.766,
    cy: 183.562,
    r: 0.12997,
    transform: "rotate(-24.5487 447.766 183.562)",
    fill: "#76FFD5"
  }))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.766,
    cy: 183.562,
    r: 0.12997,
    transform: "rotate(-24.5487 447.766 183.562)",
    fill: "url(#paint49_radial_2617_303)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.08,
    cy: 162.655,
    r: 0.276456,
    transform: "rotate(-146.463 448.08 162.655)",
    fill: "url(#paint50_radial_2617_303)"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter37_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191.492,
    cy: 157.494,
    r: 1.12898,
    transform: "rotate(24.1185 191.492 157.494)",
    fill: "#76FFD5"
  }))), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191.492,
    cy: 157.494,
    r: 1.12898,
    transform: "rotate(24.1185 191.492 157.494)",
    fill: "url(#paint51_radial_2617_303)"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter38_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 203.535,
    cy: 183.089,
    r: 0.752656,
    transform: "rotate(24.1185 203.535 183.089)",
    fill: "#76FFD5"
  }))), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 203.535,
    cy: 183.089,
    r: 0.752656,
    transform: "rotate(24.1185 203.535 183.089)",
    fill: "url(#paint52_radial_2617_303)"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter39_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 212.65,
    cy: 156.68,
    r: 0.376328,
    transform: "rotate(24.1185 212.65 156.68)",
    fill: "#76FFD5"
  }))), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 212.65,
    cy: 156.68,
    r: 0.376328,
    transform: "rotate(24.1185 212.65 156.68)",
    fill: "url(#paint53_radial_2617_303)"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter40_f_2617_303)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 191.995,
    cy: 169.264,
    r: 0.376328,
    transform: "rotate(24.1185 191.995 169.264)",
    fill: "#76FFD5"
  }))), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 191.995,
    cy: 169.264,
    r: 0.376328,
    transform: "rotate(24.1185 191.995 169.264)",
    fill: "url(#paint54_radial_2617_303)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.322,
    cy: 191.655,
    r: 0.276456,
    transform: "rotate(-146.463 208.322 191.655)",
    fill: "url(#paint55_radial_2617_303)"
  })), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 161.002,
    width: 22,
    height: 22,
    rx: 5,
    fill: "url(#paint56_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 161.502,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "url(#paint57_linear_2617_303)",
    strokeOpacity: 0.3
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 161.002,
    width: 22,
    height: 22,
    rx: 5,
    fill: "url(#paint58_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.5,
    y: 161.502,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "url(#paint59_linear_2617_303)",
    strokeOpacity: 0.3
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_2617_303)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 163.002,
    width: 22,
    height: 22,
    rx: 5,
    fill: "url(#paint60_linear_2617_303)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.5,
    y: 163.502,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "url(#paint61_linear_2617_303)",
    strokeOpacity: 0.3
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.961 166.093V177.002H111.654V168.282H111.591L109.092 169.848V167.803L111.793 166.093H113.961Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M134.423 177.002V167.547H140.794V169.195H136.422V171.448H140.466V173.096H136.422V175.354H140.812V177.002H134.423ZM142.346 177.002V169.911H144.312V177.002H142.346ZM143.334 168.997C143.041 168.997 142.791 168.9 142.581 168.706C142.375 168.509 142.272 168.274 142.272 168C142.272 167.729 142.375 167.497 142.581 167.303C142.791 167.106 143.041 167.007 143.334 167.007C143.626 167.007 143.875 167.106 144.082 167.303C144.291 167.497 144.396 167.729 144.396 168C144.396 168.274 144.291 168.509 144.082 168.706C143.875 168.9 143.626 168.997 143.334 168.997ZM147.854 172.903V177.002H145.888V169.911H147.762V171.162H147.845C148.002 170.75 148.265 170.423 148.635 170.183C149.004 169.94 149.452 169.819 149.978 169.819C150.47 169.819 150.9 169.926 151.266 170.142C151.632 170.357 151.917 170.665 152.12 171.065C152.323 171.462 152.425 171.936 152.425 172.487V177.002H150.458V172.838C150.461 172.404 150.35 172.065 150.126 171.822C149.901 171.576 149.592 171.453 149.198 171.453C148.933 171.453 148.699 171.51 148.496 171.624C148.296 171.738 148.139 171.904 148.025 172.122C147.914 172.338 147.858 172.598 147.854 172.903ZM155.757 174.961L155.761 172.602H156.048L158.319 169.911H160.576L157.525 173.475H157.059L155.757 174.961ZM153.975 177.002V167.547H155.941V177.002H153.975ZM158.407 177.002L156.32 173.914L157.631 172.524L160.71 177.002H158.407ZM163.563 177.136C163.111 177.136 162.708 177.057 162.354 176.9C162 176.74 161.72 176.505 161.513 176.194C161.31 175.88 161.209 175.489 161.209 175.021C161.209 174.628 161.281 174.297 161.426 174.029C161.57 173.761 161.767 173.546 162.017 173.383C162.266 173.22 162.549 173.096 162.866 173.013C163.186 172.93 163.522 172.872 163.872 172.838C164.285 172.795 164.617 172.755 164.87 172.718C165.122 172.678 165.305 172.619 165.419 172.542C165.533 172.465 165.59 172.352 165.59 172.201V172.173C165.59 171.881 165.497 171.655 165.313 171.494C165.131 171.334 164.873 171.254 164.537 171.254C164.183 171.254 163.902 171.333 163.692 171.49C163.483 171.644 163.345 171.838 163.277 172.072L161.458 171.924C161.55 171.493 161.732 171.121 162.003 170.807C162.274 170.49 162.623 170.247 163.051 170.077C163.482 169.905 163.98 169.819 164.546 169.819C164.94 169.819 165.317 169.865 165.678 169.957C166.041 170.05 166.362 170.193 166.642 170.387C166.926 170.58 167.149 170.83 167.312 171.134C167.475 171.436 167.556 171.798 167.556 172.219V177.002H165.691V176.019H165.636C165.522 176.24 165.37 176.436 165.179 176.605C164.988 176.771 164.759 176.902 164.491 176.997C164.223 177.09 163.914 177.136 163.563 177.136ZM164.126 175.779C164.416 175.779 164.671 175.722 164.893 175.608C165.114 175.491 165.288 175.334 165.414 175.137C165.541 174.94 165.604 174.717 165.604 174.468V173.715C165.542 173.755 165.457 173.792 165.35 173.826C165.245 173.857 165.127 173.886 164.994 173.914C164.862 173.938 164.73 173.961 164.597 173.983C164.465 174.001 164.345 174.018 164.237 174.034C164.006 174.067 163.805 174.121 163.632 174.195C163.46 174.269 163.326 174.369 163.231 174.495C163.135 174.618 163.088 174.772 163.088 174.957C163.088 175.225 163.185 175.429 163.379 175.571C163.575 175.709 163.825 175.779 164.126 175.779ZM173.629 173.983V169.911H175.596V177.002H173.708V175.714H173.634C173.474 176.129 173.208 176.463 172.835 176.716C172.466 176.968 172.015 177.094 171.483 177.094C171.009 177.094 170.592 176.987 170.232 176.771C169.872 176.556 169.59 176.249 169.387 175.852C169.187 175.455 169.085 174.98 169.082 174.426V169.911H171.049V174.075C171.052 174.494 171.164 174.825 171.386 175.068C171.607 175.311 171.904 175.432 172.277 175.432C172.514 175.432 172.735 175.378 172.942 175.271C173.148 175.16 173.314 174.997 173.44 174.781C173.569 174.566 173.632 174.3 173.629 173.983ZM180.982 169.911V171.388H176.606V169.911H180.982ZM177.608 177.002V169.399C177.608 168.885 177.708 168.458 177.908 168.12C178.111 167.781 178.388 167.527 178.739 167.358C179.09 167.189 179.488 167.104 179.934 167.104C180.236 167.104 180.511 167.127 180.761 167.173C181.013 167.22 181.201 167.261 181.324 167.298L180.973 168.775C180.896 168.751 180.801 168.728 180.687 168.706C180.576 168.685 180.462 168.674 180.345 168.674C180.056 168.674 179.854 168.742 179.74 168.877C179.627 169.009 179.57 169.195 179.57 169.436V177.002H177.608Z",
    fill: "#76FFD5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M247.219 170.267C247.182 169.894 247.023 169.605 246.743 169.399C246.463 169.192 246.083 169.089 245.603 169.089C245.277 169.089 245.001 169.135 244.777 169.228C244.552 169.317 244.38 169.442 244.26 169.602C244.143 169.762 244.084 169.943 244.084 170.146C244.078 170.316 244.113 170.463 244.19 170.59C244.27 170.716 244.38 170.825 244.518 170.917C244.657 171.007 244.817 171.085 244.998 171.153C245.18 171.218 245.374 171.273 245.58 171.319L246.429 171.522C246.842 171.615 247.22 171.738 247.565 171.892C247.91 172.045 248.208 172.235 248.461 172.459C248.713 172.684 248.908 172.949 249.047 173.253C249.188 173.558 249.261 173.907 249.264 174.301C249.261 174.88 249.113 175.382 248.821 175.806C248.531 176.228 248.113 176.556 247.565 176.79C247.02 177.02 246.363 177.136 245.594 177.136C244.83 177.136 244.166 177.019 243.599 176.785C243.036 176.551 242.596 176.205 242.279 175.746C241.965 175.285 241.801 174.714 241.785 174.034H243.719C243.741 174.351 243.832 174.615 243.992 174.828C244.155 175.037 244.372 175.195 244.643 175.303C244.917 175.408 245.226 175.46 245.571 175.46C245.909 175.46 246.203 175.411 246.452 175.312C246.705 175.214 246.9 175.077 247.039 174.901C247.177 174.726 247.246 174.524 247.246 174.297C247.246 174.084 247.183 173.906 247.057 173.761C246.934 173.617 246.752 173.493 246.512 173.392C246.275 173.29 245.985 173.198 245.64 173.115L244.61 172.856C243.813 172.662 243.184 172.359 242.722 171.947C242.261 171.535 242.031 170.979 242.034 170.28C242.031 169.708 242.184 169.208 242.491 168.78C242.802 168.352 243.229 168.018 243.77 167.778C244.312 167.538 244.927 167.418 245.617 167.418C246.318 167.418 246.931 167.538 247.454 167.778C247.98 168.018 248.39 168.352 248.682 168.78C248.975 169.208 249.125 169.703 249.135 170.267H247.219ZM253.803 177.14C253.074 177.14 252.446 176.993 251.919 176.697C251.396 176.399 250.993 175.977 250.71 175.432C250.427 174.885 250.285 174.237 250.285 173.489C250.285 172.759 250.427 172.119 250.71 171.568C250.993 171.017 251.392 170.588 251.906 170.28C252.423 169.973 253.029 169.819 253.724 169.819C254.192 169.819 254.628 169.894 255.031 170.045C255.437 170.193 255.791 170.416 256.093 170.714C256.397 171.013 256.634 171.388 256.804 171.841C256.973 172.29 257.058 172.816 257.058 173.42V173.96H251.07V172.741H255.206C255.206 172.458 255.145 172.207 255.022 171.988C254.899 171.77 254.728 171.599 254.509 171.476C254.294 171.35 254.043 171.287 253.757 171.287C253.458 171.287 253.194 171.356 252.963 171.494C252.735 171.63 252.557 171.813 252.427 172.044C252.298 172.272 252.232 172.526 252.229 172.806V173.964C252.229 174.315 252.293 174.618 252.423 174.874C252.555 175.129 252.741 175.326 252.981 175.465C253.221 175.603 253.506 175.672 253.835 175.672C254.054 175.672 254.254 175.642 254.435 175.58C254.617 175.519 254.772 175.426 254.902 175.303C255.031 175.18 255.129 175.029 255.197 174.851L257.016 174.971C256.924 175.408 256.734 175.789 256.448 176.116C256.165 176.439 255.799 176.691 255.349 176.873C254.903 177.051 254.388 177.14 253.803 177.14ZM260.308 172.903V177.002H258.341V169.911H260.215V171.162H260.298C260.455 170.75 260.718 170.423 261.088 170.183C261.457 169.94 261.905 169.819 262.431 169.819C262.924 169.819 263.353 169.926 263.719 170.142C264.085 170.357 264.37 170.665 264.573 171.065C264.776 171.462 264.878 171.936 264.878 172.487V177.002H262.911V172.838C262.914 172.404 262.804 172.065 262.579 171.822C262.354 171.576 262.045 171.453 261.651 171.453C261.386 171.453 261.152 171.51 260.949 171.624C260.749 171.738 260.592 171.904 260.478 172.122C260.368 172.338 260.311 172.598 260.308 172.903ZM269.041 177.117C268.502 177.117 268.014 176.979 267.577 176.702C267.143 176.422 266.799 176.011 266.543 175.469C266.291 174.925 266.165 174.257 266.165 173.466C266.165 172.653 266.296 171.978 266.557 171.439C266.819 170.897 267.167 170.493 267.6 170.225C268.037 169.954 268.516 169.819 269.036 169.819C269.433 169.819 269.764 169.886 270.029 170.022C270.296 170.154 270.512 170.32 270.675 170.52C270.841 170.717 270.967 170.911 271.054 171.102H271.114V167.547H273.076V177.002H271.137V175.866H271.054C270.961 176.063 270.83 176.259 270.661 176.453C270.495 176.643 270.278 176.802 270.01 176.928C269.746 177.054 269.422 177.117 269.041 177.117ZM269.664 175.552C269.981 175.552 270.249 175.466 270.467 175.294C270.689 175.118 270.858 174.874 270.975 174.56C271.095 174.246 271.155 173.878 271.155 173.456C271.155 173.035 271.097 172.669 270.98 172.358C270.863 172.047 270.693 171.807 270.472 171.638C270.25 171.468 269.981 171.384 269.664 171.384C269.341 171.384 269.068 171.471 268.847 171.647C268.625 171.822 268.458 172.065 268.344 172.376C268.23 172.687 268.173 173.047 268.173 173.456C268.173 173.869 268.23 174.234 268.344 174.551C268.461 174.865 268.628 175.111 268.847 175.289C269.068 175.465 269.341 175.552 269.664 175.552ZM279.11 172.339V173.9H274.799V172.339H279.11ZM282.822 167.547V177.002H280.823V167.547H282.822ZM286.396 172.903V177.002H284.43V169.911H286.304V171.162H286.387C286.544 170.75 286.807 170.423 287.177 170.183C287.546 169.94 287.994 169.819 288.52 169.819C289.012 169.819 289.442 169.926 289.808 170.142C290.174 170.357 290.459 170.665 290.662 171.065C290.865 171.462 290.967 171.936 290.967 172.487V177.002H289V172.838C289.003 172.404 288.892 172.065 288.668 171.822C288.443 171.576 288.134 171.453 287.74 171.453C287.475 171.453 287.241 171.51 287.038 171.624C286.838 171.738 286.681 171.904 286.567 172.122C286.456 172.338 286.4 172.598 286.396 172.903Z",
    fill: "#76FFD5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M360.328 179.002V169.547H364.058C364.775 169.547 365.386 169.684 365.89 169.958C366.395 170.229 366.78 170.606 367.045 171.089C367.312 171.569 367.446 172.123 367.446 172.751C367.446 173.379 367.311 173.933 367.04 174.413C366.769 174.893 366.377 175.267 365.863 175.535C365.352 175.803 364.733 175.937 364.007 175.937H361.629V174.335H363.684C364.068 174.335 364.385 174.269 364.635 174.136C364.887 174.001 365.075 173.815 365.198 173.578C365.324 173.338 365.387 173.062 365.387 172.751C365.387 172.437 365.324 172.163 365.198 171.93C365.075 171.693 364.887 171.509 364.635 171.38C364.382 171.248 364.062 171.182 363.675 171.182H362.327V179.002H360.328ZM368.708 179.002V171.911H370.614V173.148H370.688C370.817 172.708 371.034 172.376 371.339 172.151C371.644 171.923 371.995 171.809 372.392 171.809C372.49 171.809 372.596 171.816 372.71 171.828C372.824 171.84 372.924 171.857 373.01 171.879V173.624C372.918 173.596 372.79 173.571 372.627 173.55C372.464 173.528 372.315 173.518 372.179 173.518C371.89 173.518 371.631 173.581 371.404 173.707C371.179 173.83 371.001 174.002 370.868 174.224C370.739 174.445 370.674 174.701 370.674 174.99V179.002H368.708ZM376.901 179.14C376.184 179.14 375.564 178.988 375.04 178.683C374.52 178.376 374.119 177.948 373.835 177.4C373.552 176.849 373.411 176.211 373.411 175.484C373.411 174.752 373.552 174.112 373.835 173.564C374.119 173.013 374.52 172.585 375.04 172.28C375.564 171.973 376.184 171.819 376.901 171.819C377.618 171.819 378.236 171.973 378.757 172.28C379.28 172.585 379.683 173.013 379.966 173.564C380.249 174.112 380.391 174.752 380.391 175.484C380.391 176.211 380.249 176.849 379.966 177.4C379.683 177.948 379.28 178.376 378.757 178.683C378.236 178.988 377.618 179.14 376.901 179.14ZM376.91 177.617C377.236 177.617 377.509 177.525 377.727 177.34C377.946 177.152 378.11 176.897 378.221 176.574C378.335 176.251 378.392 175.883 378.392 175.47C378.392 175.058 378.335 174.69 378.221 174.367C378.11 174.044 377.946 173.788 377.727 173.601C377.509 173.413 377.236 173.319 376.91 173.319C376.581 173.319 376.304 173.413 376.079 173.601C375.857 173.788 375.69 174.044 375.576 174.367C375.465 174.69 375.41 175.058 375.41 175.47C375.41 175.883 375.465 176.251 375.576 176.574C375.69 176.897 375.857 177.152 376.079 177.34C376.304 177.525 376.581 177.617 376.91 177.617ZM385.483 171.911V173.388H381.106V171.911H385.483ZM382.108 179.002V171.399C382.108 170.885 382.208 170.458 382.408 170.12C382.611 169.781 382.888 169.527 383.239 169.358C383.59 169.189 383.989 169.104 384.435 169.104C384.736 169.104 385.012 169.127 385.261 169.173C385.514 169.22 385.701 169.261 385.824 169.298L385.474 170.775C385.397 170.751 385.301 170.728 385.187 170.706C385.077 170.685 384.963 170.674 384.846 170.674C384.556 170.674 384.355 170.742 384.241 170.877C384.127 171.009 384.07 171.195 384.07 171.436V179.002H382.108ZM386.684 179.002V171.911H388.651V179.002H386.684ZM387.672 170.997C387.38 170.997 387.129 170.9 386.92 170.706C386.713 170.509 386.61 170.274 386.61 170C386.61 169.729 386.713 169.497 386.92 169.303C387.129 169.106 387.38 169.007 387.672 169.007C387.965 169.007 388.214 169.106 388.42 169.303C388.629 169.497 388.734 169.729 388.734 170C388.734 170.274 388.629 170.509 388.42 170.706C388.214 170.9 387.965 170.997 387.672 170.997ZM393.998 171.911V173.388H389.728V171.911H393.998ZM390.697 170.212H392.664V176.823C392.664 177.005 392.691 177.146 392.747 177.248C392.802 177.346 392.879 177.415 392.978 177.455C393.079 177.495 393.196 177.515 393.328 177.515C393.421 177.515 393.513 177.508 393.605 177.492C393.698 177.474 393.769 177.46 393.818 177.451L394.127 178.914C394.029 178.945 393.89 178.98 393.712 179.02C393.533 179.064 393.316 179.09 393.061 179.099C392.587 179.117 392.171 179.054 391.814 178.91C391.46 178.765 391.185 178.54 390.988 178.236C390.791 177.931 390.694 177.546 390.697 177.081V170.212Z",
    fill: "#76FFD5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M218.66 177.002V175.34L222.543 171.744C222.874 171.425 223.151 171.137 223.374 170.882C223.602 170.626 223.774 170.376 223.891 170.131C224.008 169.882 224.067 169.614 224.067 169.326C224.067 169.007 223.994 168.731 223.848 168.501C223.703 168.266 223.504 168.087 223.252 167.963C223 167.835 222.714 167.771 222.394 167.771C222.06 167.771 221.769 167.838 221.521 167.973C221.272 168.108 221.08 168.302 220.945 168.554C220.81 168.806 220.743 169.106 220.743 169.454H218.554C218.554 168.74 218.715 168.121 219.038 167.595C219.361 167.069 219.814 166.663 220.397 166.375C220.979 166.088 221.65 165.944 222.41 165.944C223.191 165.944 223.871 166.082 224.45 166.359C225.033 166.633 225.485 167.013 225.809 167.499C226.132 167.986 226.293 168.543 226.293 169.172C226.293 169.584 226.212 169.99 226.048 170.392C225.888 170.793 225.603 171.238 225.191 171.729C224.779 172.215 224.198 172.799 223.449 173.481L221.856 175.042V175.116H226.437V177.002H218.66Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M332.473 179.151C331.677 179.151 330.969 179.014 330.347 178.741C329.729 178.464 329.241 178.084 328.883 177.601C328.527 177.115 328.345 176.553 328.334 175.918H330.656C330.67 176.184 330.758 176.419 330.917 176.621C331.081 176.82 331.297 176.974 331.567 177.084C331.837 177.194 332.141 177.249 332.478 177.249C332.83 177.249 333.14 177.187 333.41 177.063C333.68 176.939 333.891 176.767 334.044 176.546C334.197 176.326 334.273 176.072 334.273 175.785C334.273 175.493 334.191 175.236 334.028 175.012C333.868 174.785 333.637 174.607 333.336 174.48C333.037 174.352 332.682 174.288 332.27 174.288H331.253V172.594H332.27C332.618 172.594 332.925 172.534 333.192 172.413C333.462 172.292 333.671 172.125 333.82 171.912C333.97 171.695 334.044 171.443 334.044 171.156C334.044 170.882 333.978 170.643 333.847 170.437C333.719 170.227 333.538 170.064 333.304 169.947C333.073 169.829 332.803 169.771 332.494 169.771C332.182 169.771 331.896 169.828 331.636 169.941C331.377 170.051 331.169 170.209 331.013 170.415C330.857 170.621 330.773 170.863 330.763 171.14H328.552C328.563 170.511 328.742 169.957 329.09 169.478C329.438 168.998 329.907 168.624 330.496 168.354C331.09 168.08 331.759 167.944 332.505 167.944C333.258 167.944 333.916 168.08 334.481 168.354C335.045 168.627 335.484 168.997 335.797 169.462C336.113 169.923 336.269 170.442 336.265 171.017C336.269 171.628 336.079 172.138 335.695 172.546C335.315 172.954 334.82 173.214 334.209 173.324V173.409C335.012 173.512 335.623 173.791 336.042 174.245C336.464 174.696 336.674 175.261 336.67 175.939C336.674 176.561 336.494 177.113 336.132 177.596C335.773 178.079 335.278 178.459 334.646 178.736C334.014 179.013 333.289 179.151 332.473 179.151Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.033 121.721C162.976 117.869 164.745 113.081 164.745 107.872C164.745 95.259 154.486 85 141.872 85C129.259 85 119 95.259 119 107.872C119 120.486 129.259 130.745 141.872 130.745C147.081 130.745 151.872 128.976 155.724 126.033L168.688 139L173 134.688L160.033 121.721ZM141.872 124.645C132.623 124.645 125.099 117.119 125.099 107.872C125.099 98.6258 132.623 91.0993 141.872 91.0993C151.122 91.0993 158.645 98.6258 158.645 107.872C158.645 117.119 151.122 124.645 141.872 124.645Z",
    fill: "url(#paint62_linear_2617_303)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 118C135.649 118 135.757 117.891 135.786 117.737C136.192 114.601 136.632 114.127 139.731 113.783C139.891 113.766 140 113.646 140 113.497C140 113.348 139.891 113.234 139.731 113.211C136.632 112.868 136.192 112.393 135.786 109.257C135.757 109.103 135.649 109 135.5 109C135.351 109 135.243 109.103 135.22 109.257C134.814 112.393 134.368 112.868 131.274 113.211C131.109 113.234 131 113.348 131 113.497C131 113.646 131.109 113.766 131.274 113.783C134.362 114.189 134.791 114.607 135.22 117.737C135.243 117.891 135.351 118 135.5 118Z",
    fill: "url(#paint63_linear_2617_303)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146 115C146.297 115 146.515 114.783 146.572 114.474C147.384 108.203 148.264 107.253 154.462 106.566C154.783 106.532 155 106.292 155 105.994C155 105.697 154.783 105.468 154.462 105.422C148.264 104.736 147.384 103.786 146.572 97.5149C146.515 97.206 146.297 97 146 97C145.703 97 145.485 97.206 145.44 97.5149C144.628 103.786 143.736 104.736 137.549 105.422C137.217 105.468 137 105.697 137 105.994C137 106.292 137.217 106.532 137.549 106.566C143.724 107.379 144.582 108.214 145.44 114.474C145.485 114.783 145.703 115 146 115Z",
    fill: "url(#paint64_linear_2617_303)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.463 119H235.537C235.24 119 235 119.244 235 119.545V127.455C235 127.756 235.24 128 235.537 128H256.463C256.76 128 257 127.756 257 127.455V119.545C257 119.244 256.76 119 256.463 119Z",
    fill: "url(#paint65_linear_2617_303)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M273.862 87.3271L278 95.6H230L234.138 87.3271C234.337 86.9286 234.643 86.5933 235.022 86.3589C235.401 86.1245 235.838 86.0002 236.283 86H271.717C272.162 86.0002 272.599 86.1245 272.978 86.3589C273.357 86.5933 273.663 86.9286 273.862 87.3271ZM230 100.4H278V131.6C278 132.236 277.747 132.847 277.297 133.297C276.847 133.747 276.236 134 275.6 134H232.4C231.764 134 231.153 133.747 230.703 133.297C230.253 132.847 230 132.236 230 131.6V100.4ZM237.2 124.4C237.2 125.036 237.453 125.647 237.903 126.097C238.353 126.547 238.964 126.8 239.6 126.8H249.2C249.836 126.8 250.447 126.547 250.897 126.097C251.347 125.647 251.6 125.036 251.6 124.4C251.6 123.764 251.347 123.153 250.897 122.703C250.447 122.253 249.836 122 249.2 122H239.6C238.964 122 238.353 122.253 237.903 122.703C237.453 123.153 237.2 123.764 237.2 124.4Z",
    fill: "url(#paint66_radial_2617_303)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.225 119.409C270.05 119.205 271.963 118.877 272.776 119.048C273.92 119.145 274.609 119.326 274.838 119.59C275.323 120.277 274.596 122.685 274.265 123.469C273.973 124.16 272.606 126.376 271.898 126.376C271.682 126.376 271.518 126.225 271.629 125.944C274.227 120.168 273.066 120.32 269.225 120.636C268.729 120.694 266.911 121.041 267.125 120.636C267.695 120.134 268.723 119.532 269.225 119.409ZM233.68 119.877C240.043 123.367 246.966 125.113 254.45 125.113C259.437 125.113 264.364 124.234 269.225 122.477C269.962 122.199 270.739 121.657 271.19 122.26C271.407 122.55 271.337 122.814 270.98 123.055C266.27 126.271 259.706 128 253.99 128C245.904 128 238.71 125.163 233.223 120.491C232.734 120.108 233.124 119.543 233.68 119.877Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M376.481 104.677L374.38 109.361H346L347.719 104.677H376.481ZM372.427 113.639L370.113 118.43H346L347.719 113.639H372.427ZM382 92.9781L378.604 100.293C378.038 99.8935 377.351 99.4586 376.545 98.9881C375.752 98.5033 374.84 98.097 373.807 97.769C372.788 97.4268 371.656 97.2557 370.41 97.2557C368.443 97.2557 366.731 97.7548 365.274 98.7529C363.816 99.751 362.684 101.305 361.877 103.415C361.085 105.526 360.689 108.235 360.689 111.543C360.689 114.879 361.085 117.596 361.877 119.692C362.684 121.773 363.816 123.306 365.274 124.29C366.731 125.26 368.443 125.744 370.41 125.744C371.656 125.744 372.788 125.58 373.807 125.252C374.825 124.924 375.717 124.532 376.481 124.076C377.259 123.62 377.91 123.199 378.434 122.814L381.873 130.129C380.33 131.412 378.583 132.382 376.63 133.038C374.677 133.679 372.604 134 370.41 134C366.703 134 363.42 133.116 360.561 131.348C357.717 129.566 355.488 127.006 353.875 123.67C352.262 120.319 351.455 116.277 351.455 111.543C351.455 106.823 352.262 102.781 353.875 99.4159C355.488 96.0509 357.717 93.4772 360.561 91.6949C363.42 89.8983 366.703 89 370.41 89C372.689 89 374.797 89.3422 376.736 90.0266C378.675 90.711 380.429 91.6949 382 92.9781Z",
    fill: "url(#paint67_linear_2617_303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2617_303",
    x: 393.686,
    y: 43.9707,
    width: 11.5055,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2617_303",
    x: 365.052,
    y: 11.0518,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2617_303",
    x: 385.093,
    y: 27.8145,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2617_303",
    x: 310.488,
    y: 44.0625,
    width: 12.2581,
    height: 12.2583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2617_303",
    x: 328.63,
    y: 52.2554,
    width: 11.5054,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2617_303",
    x: 184.953,
    y: 51.5586,
    width: 11.5054,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2617_303",
    x: 406.242,
    y: 101.325,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_2617_303",
    x: 212.972,
    y: 47.8799,
    width: 10.7527,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2617_303",
    x: 301.021,
    y: 50.6763,
    width: 10.7527,
    height: 10.7524,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2617_303",
    x: 249.242,
    y: 160.244,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2617_303",
    x: 110.686,
    y: 41.9707,
    width: 11.5055,
    height: 11.5054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2617_303",
    x: 82.0519,
    y: 9.05176,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2617_303",
    x: 102.093,
    y: 25.8145,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2617_303",
    x: 67.1199,
    y: 93.1816,
    width: 12.2585,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2617_303",
    x: 82.6098,
    y: 81.3794,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2617_303",
    x: 79.5393,
    y: 119.154,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2617_303",
    x: 49.2416,
    y: 103.94,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2617_303",
    x: 89.031,
    y: 93.1206,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_2617_303",
    x: 68.3757,
    y: 105.705,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_2617_303",
    x: 94.6064,
    y: 167.091,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_2617_303",
    x: 82.1208,
    y: 69.1206,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_2617_303",
    x: 87.6963,
    y: 143.091,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_2617_303",
    x: 97.108,
    y: 64.2095,
    width: 93.7602,
    height: 94.4014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_2617_303",
    x: 207.171,
    y: 63,
    width: 93.7602,
    height: 94.4014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_2617_303",
    x: 317.234,
    y: 63,
    width: 93.7602,
    height: 94.4014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_2617_303",
    x: 83.8439,
    y: 139.85,
    width: 10.52,
    height: 10.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_2617_303",
    x: 88.2999,
    y: 141.004,
    width: 10.26,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_2617_303",
    x: 84.6364,
    y: 149.251,
    width: 10.26,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_2617_303",
    x: 425.12,
    y: 122.362,
    width: 12.2585,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_2617_303",
    x: 437.539,
    y: 148.336,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_2617_303",
    x: 407.242,
    y: 133.121,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_2617_303",
    x: 447.031,
    y: 122.301,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_2617_303",
    x: 426.376,
    y: 134.885,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_2617_303",
    x: 445.696,
    y: 172.272,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_2617_303",
    x: 441.844,
    y: 169.031,
    width: 10.52,
    height: 10.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_2617_303",
    x: 446.3,
    y: 170.185,
    width: 10.26,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_2617_303",
    x: 442.636,
    y: 178.432,
    width: 10.26,
    height: 10.2603,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_2617_303",
    x: 185.362,
    y: 151.364,
    width: 12.2585,
    height: 12.2588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_2617_303",
    x: 197.782,
    y: 177.336,
    width: 11.5057,
    height: 11.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_2617_303",
    x: 207.274,
    y: 151.303,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_2617_303",
    x: 186.618,
    y: 163.887,
    width: 10.7528,
    height: 10.7529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_2617_303"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_2617_303",
    x: 97,
    y: 157.002,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_2617_303",
    x: 207,
    y: 157.002,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_2617_303",
    x: 317,
    y: 159.002,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2617_303"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2617_303",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2617_303",
    x1: 157.368,
    y1: 161.002,
    x2: 157.865,
    y2: 182.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CFFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2617_303",
    x1: 266.87,
    y1: 161.002,
    x2: 267.375,
    y2: 182.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CFFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFD3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2617_303",
    x1: 376.87,
    y1: 163.002,
    x2: 377.375,
    y2: 184.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CFFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BFFD3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(399.438 49.7234) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(370.428 16.4281) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(390.47 33.1908) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(316.617 50.1915) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(334.383 58.0082) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.706 57.3115) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(411.994 107.078) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.348 53.2561) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(306.397 56.0525) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(254.995 165.996) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.438 47.7234) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.4284 14.4281) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.47 31.1908) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.2492 99.3111) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.3627 87.1322) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.2922 124.907) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9945 109.693) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.4074 98.4973) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.7521 111.081) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.359 172.844) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.4973 74.4973) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.4492 148.844) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2617_303",
    x1: -41.6053,
    y1: -3.23428,
    x2: 47.3571,
    y2: 48.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2617_303",
    x1: 70.7232,
    y1: -0.0000034329,
    x2: 15.0265,
    y2: 86.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#479980",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2617_303",
    x1: 143.946,
    y1: 68.4219,
    x2: 143.946,
    y2: 111.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2617_303",
    x1: 101.013,
    y1: 90.0223,
    x2: 186.853,
    y2: 90.0733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2617_303",
    x1: -41.6053,
    y1: -3.23428,
    x2: 47.3571,
    y2: 48.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2617_303",
    x1: 31.156,
    y1: 4.57489e-7,
    x2: 54.5705,
    y2: 86.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#479980",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2617_303",
    x1: 254.009,
    y1: 67.2124,
    x2: 254.009,
    y2: 110.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2617_303",
    x1: 211.076,
    y1: 88.8128,
    x2: 296.916,
    y2: 88.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2617_303",
    x1: -41.6053,
    y1: -3.23428,
    x2: 47.3571,
    y2: 48.5081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06060A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09090D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2617_303",
    x1: 42.8597,
    y1: 0.00000135751,
    x2: 88.7949,
    y2: 89.4886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2617_303",
    x1: 364.072,
    y1: 67.2124,
    x2: 364.072,
    y2: 110.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EF2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2617_303",
    x1: 321.139,
    y1: 88.8128,
    x2: 406.979,
    y2: 88.8639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19DCA1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#43FFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D7656",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.104 145.11) rotate(90) scale(0.346587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.4299 146.135) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.7663 154.382) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0798 133.472) rotate(90) scale(0.368608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.249 128.492) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(443.292 154.089) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(412.994 138.873) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(452.407 127.678) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(431.752 140.262) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.449 178.025) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(447.104 174.291) rotate(90) scale(0.346587)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(451.43 175.315) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(447.766 183.562) rotate(90) scale(0.173294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(448.08 162.655) rotate(90) scale(0.368608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.492 157.494) rotate(90) scale(1.50531)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.535 183.089) rotate(90) scale(1.00354)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(212.65 156.68) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.995 169.264) rotate(90) scale(0.50177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.322 191.655) rotate(90) scale(0.368608)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2617_303",
    x1: 109.337,
    y1: 160.741,
    x2: 100.39,
    y2: 167.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CD9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2617_303",
    x1: 111.079,
    y1: 161.002,
    x2: 121.53,
    y2: 177.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2617_303",
    x1: 219.337,
    y1: 160.741,
    x2: 210.39,
    y2: 167.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CD9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2617_303",
    x1: 221.079,
    y1: 161.002,
    x2: 231.53,
    y2: 177.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2617_303",
    x1: 329.337,
    y1: 162.741,
    x2: 320.39,
    y2: 169.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23CD9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2617_303",
    x1: 331.079,
    y1: 163.002,
    x2: 341.53,
    y2: 179.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76FFD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2617_303",
    x1: 146,
    y1: 85,
    x2: 146,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2617_303",
    x1: 146,
    y1: 85,
    x2: 146,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2617_303",
    x1: 146,
    y1: 85,
    x2: 146,
    y2: 139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BF7BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DA77E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2617_303",
    x1: 248,
    y1: 117.875,
    x2: 245.5,
    y2: 127.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BE1AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17CF97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_2617_303",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(252.065 110) rotate(99.6375) scale(20.8098 20.8314)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FDD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14CE95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2617_303",
    x1: 364,
    y1: 89,
    x2: 364,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24CD9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.6db2aff89a09786299296ed01bd99d30.svg";
export { ForwardRef as ReactComponent };